import axios from 'axios';

// const backendUrl = 'http://localhost:21494'
// const backendUrl = 'https://apps.delphus.inf.br:4236' //ambiente teste
// const backendUrl = 'http://192.168.0.18:21494'
var backendUrl = 'https://ksasistema.sysop.com.br:21495'
if(window.location.origin == 'http://localhost:3000' || window.location.origin == 'http://localhost:3001') {
    backendUrl = 'http://localhost:21494'
} else if(window.location.origin == 'https://apps.delphus.inf.br'){
    backendUrl = 'https://apps.delphus.inf.br:4236'
}



const auth = JSON.parse(localStorage.getItem('authKSA')) || null
const api = axios.create({
    baseURL: backendUrl + `/api/`
});

api.interceptors.request.use(function (config) {
    var token = auth?.access_token
    if(window.location.href.includes('sistema/vendadireta') || window.location.href.includes('sistema/vendaexterna')) {
        token='noTokenRequired'
    }
    config.headers.token = token;
     
    return config;
});

api.getComboData = async (table, parameter, query) => {
    return new Promise(async (resolve, reject) => {
        console.log('Searching for parameter ' + parameter)
        await api.get('/' + table + '/combo' + (parameter ? '/' + parameter : '') + (query ? '?' + query : '')).then(async r => {
            console.log(r.data)
            resolve(r.data)
        })
    })
}

api.getListData = async (table, parameter) => {
    return new Promise(async (resolve, reject) => {
        console.log('Searching for parameter ' + parameter)
        await api.get('/' + table + '/lista' + (parameter ? '/' + parameter : '')).then(async r => {
            console.log(r.data)
            resolve(r.data)
        })
    })
}

api.getImage = async (lote, image) => {
    return new Promise(async (resolve, reject) => {
        if (lote && image) {
            console.log('Trying to find image ' + image + ' of lot ' + lote)
            axios.get(backendUrl + '/static/upload/lotes/' + lote + '/' + image).then(r => {
                resolve(backendUrl + '/static/upload/lotes/' + lote + '/' + image)
            }).catch(e => resolve(backendUrl + '/static/upload/lotes/no-image.jpg'))
        } else resolve(backendUrl + '/static/upload/lotes/no-image.jpg')
    })
}


api.getTipoGrupo = async (usuario) => {
    return new Promise(async (resolve, reject) => {
        await api.get('/usuario_externo?pk_uex=' + usuario).then(async r => {
            console.log(usuario)
            if (r.data[0]){
                console.log(r.data[0].TIPO_GRUPO)
                return resolve(r.data[0].TIPO_GRUPO)
            }

        })
    })
}

api.noImageUrl = backendUrl + '/static/upload/lotes/no-image.jpg'
api.backendUrl = backendUrl

export default api